var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 36,
    viewBox: "0 0 50 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1712 30.5349C25.1712 30.5349 48.0769 24.2484 49.2497 1.19751C49.2497 1.19751 47.212 9.51812 38.8777 8.96357C30.5427 8.40902 26.4682 11.1209 24.1836 16.1743C24.1836 16.1743 30.6661 9.64135 34.2469 14.8187C37.8277 19.9961 25.1712 30.5349 25.1712 30.5349Z",
    fill: "#EB9309"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5106 35.5098C25.5106 35.5098 14.8292 34.3391 7.05049 24.7237C-0.72826 15.1084 8.34668 12.1508 15.8176 14.7395C23.2885 17.3281 24.523 21.1492 24.523 21.1492C24.523 21.1492 20.9953 17.9435 16.4269 18.9294C11.8578 19.9153 13.0226 25.7388 17.2831 29.4982C21.5428 33.2576 25.5106 35.5098 25.5106 35.5098Z",
    fill: "#EB9309"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99638 10.7204C6.5511 12.4378 5.86898 14.1938 4.47387 14.6425C3.07876 15.0912 1.49769 14.0635 0.942966 12.3469C0.388246 10.6296 1.07037 8.87349 2.46548 8.4248C3.86138 7.9761 5.44166 9.00384 5.99638 10.7204Z",
    fill: "#EB9309"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4419 7.52139C41.8375 7.07232 42.5194 5.31632 41.965 3.59925C41.4106 1.88219 39.8298 0.854272 38.4342 1.30334C37.0386 1.75241 36.3567 3.50841 36.9111 5.22548C37.4656 6.94255 39.0464 7.97046 40.4419 7.52139Z",
    fill: "#EB9309"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c3212a76595a0c24502eb84748abc171.svg";
export { ForwardRef as ReactComponent };